import { Container, Row, Col } from '@mch-group/uikit-components'
import styled from 'styled-components'
import classNames from 'classnames'

import React, { FC } from 'react'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import tokensRenamed from '@constants/tokensRenamed'

const mID = 'gallery-detail-locations'

const Locations: FC<IGalleryLocationsTab> = ({ className, addresses = [] }) => {
  const [isLoading, setLoading] = React.useState(true)

  React.useEffect(() => {
    setLoading(false)
  }, [])

  return !isLoading ? (
    <Container as='section' className={classNames(`${className}`)}>
      <Row className='g-5 g-md-6 g-xl-7'>
        {addresses
          .filter((address) => address.isPrimary || address.isGallerySpace)
          .map((address) => (
            <Col key={address.id} xs={12} md={4} xl={2} className={`${mID}__content-column`}>
              <div className={`${mID}__header-address`}>{address.title}</div>
              <a href={address.mapUrl} target='_blank'>
                {address.address && <div>{address.address}</div>}
                {address.address2 && <div>{address.address2}</div>}
                {address.city && (
                  <div>
                    {address.city}
                    {`${address.zipCode ? `, ${address.zipCode}` : ''}`}
                  </div>
                )}
                {address.country && <div>{address.country}</div>}
              </a>
              {address.phoneNumber && <div>{address.phoneNumber}</div>}
              {address.emailAddress && <div>{address.emailAddress}</div>}
            </Col>
          ))}
      </Row>
    </Container>
  ) : null
}

interface IGalleryLocationsTab {
  className: string,
  addresses: Array<ABTypes.Monolith.GalleryAddress>,
  locationsLabel: string
}

export default styled(Locations)`
  &&& {
    .${mID}__header-address {
      font-size: ${tokens.fontSize[4].value};
      line-height: ${tokensRenamed.lineHeights[7].value};
      font-weight: ${tokens.fontWeights.artBaselHeadline0.value};
      color: var(--bs-mch-black);
    }
  }
`
